module.exports = __webpack_public_path__ + "static/uiux-b2ed6209c6d9afa9d86d92f6f59dcc92.png";